module.exports = __webpack_public_path__ + "static/media/react.e8cb29b4.png";